<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="600px">
    <v-card>
      <v-card-title>Create booking</v-card-title>
      <div class="text-center">
        <HtTrainingBadge :seats="numberOfSeats" :bookings="occupiedSeats" />
      </div>
      <v-card-text>
        <v-form>
          <v-autocomplete
            v-model="booking.trainingId"
            label="Course"
            :readonly="trainingReadOnly"
            :items="trainings"
            item-value="id"
            item-text="courseName"
          >
            <template
              v-slot:selection="data"
            >{{data.item.courseName}} {{formatDate(data.item.start)}} - {{formatAdress(data.item)}}</template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.courseName"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="formatDate(data.item.start)+ '  -  '+formatDate(data.item.end)"
                ></v-list-item-subtitle>
                <v-list-item-subtitle v-html="formatAdress(data.item)"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>

          <v-autocomplete
            v-model="booking.customerId"
            label="Customer"
            :readonly="customerReadOnly"
            :items="customers"
            item-value="id"
            item-text="name"
          />
          <v-text-field label="Extra text" v-model="booking.message" />
          <v-text-field label="Hairmodels" v-model.number="booking.models" />
          <v-text-field label="Dolls" v-model.number="booking.dolls" />

          <v-form>
            <div v-for="(item,k) in booking.trainingBookingAttendes" :key="k">
              <v-subheader>Attende {{k +1}}</v-subheader>
              <v-icon
                @click="removeAttendee(k)"
                v-show="k || ( !k && booking.trainingBookingAttendes.length > 1)"
              >mdi-minus</v-icon>
              <v-text-field label="Name" v-model="item.name" />
              <v-text-field label="Email" v-model="item.email" />
              <v-text-field label="Phone" v-model="item.phone" />
              <span>
                <v-icon
                  @click="addAttendee(k)"
                  v-show="k == booking.trainingBookingAttendes.length-1 && seatsLeft>0"
                >mdi-plus</v-icon>
              </span>
            </div>
          </v-form>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="$emit('input')">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="addBooking()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerAPI from "../../../../servcies/api/training/TrainingCustomer";
import trainingApi from "../../../../servcies/api/training/Training";
import trainingBookingApi from "../../../../servcies/api/training/TrainingBooking";
import HtTrainingBadge from "./HtTrainingBadge";
import moment from "moment";
import _ from "lodash";
import { userInfo } from "os";

export default {
  name: "HtTrainingBooking",
  components: { HtTrainingBadge },
  props: {
    trainingIdProp: {
      type: Number,
      default: null
    },
    customerIdProp: {
      type: Number,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      trainings: [],
      customers: [],

      trainingReadOnly: true,
      customerReadOnly: true,

      booking: {
        trainingId: this.trainingIdProp,
        customerId: this.customerIdProp,
        message: "",
        models: undefined,
        dolls: undefined,
        trainingBookingAttendes: [{ name: "", email: "", phone: "" }]
      }
    };
  },
  created() {
    this.getAllTrainings();
    this.getAllCustomers();

    if (this.trainingIdProp === null) {
      this.trainingReadOnly = false;
    }
    if (this.customerIdProp === null) {
      this.customerReadOnly = false;
    }
  },
  methods: {
    onAdded() {
      this.$emit("bookingAdded");
    },
    addAttendee(index) {
      this.booking.trainingBookingAttendes.push({
        name: "",
        email: "",
        phone: ""
      });
    },
    removeAttendee(index) {
      this.booking.trainingBookingAttendes.splice(index, 1);
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    formatAdress(item) {
      return item.adress + " " + item.zipCode + " " + item.city;
    },
    getAllTrainings() {
      trainingApi
        .getTrainings()
        .then(result => {
          this.trainings = result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllCustomers() {
      customerAPI
        .GetCustomers()
        .then(result => {
          this.customers = result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    addBooking() {
      var trainingID = this.booking.trainingId;
      trainingBookingApi
        .CreateBooking(trainingID, this.booking)
        .then(result => {
          this.onAdded();
          dialog = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    numberOfSeats() {
      var tid = this.booking.trainingId;
      var training = _.find(this.trainings, function(t) {
        return t.id == tid;
      });

      if (training == null) return 0;

      return training.availableSeats;
    },
    seatsOnTraining() {
      var tid = this.booking.trainingId;
      var training = _.find(this.trainings, function(t) {
        return t.id == tid;
      });

      if (training == null) return 0;

      var seats = 0;
      _.forEach(training.trainingBookings, element => {
        seats = seats + element.trainingBookingAttendes.length;
      });

      return seats;
    },
    seatsOnBooking() {
      return this.booking.trainingBookingAttendes.length;
    },
    occupiedSeats() {
      return this.seatsOnBooking + this.seatsOnTraining;
    },
    seatsLeft() {
      return this.numberOfSeats - (this.seatsOnTraining + this.seatsOnBooking);
    }
  },
  watch: {
    value(val) {
      if (!val) {
        this.booking.dolls = undefined;
        this.booking.models = undefined;
        this.booking.message = "";
        this.booking.trainingBookingAttendes.length = 0;
        this.booking.trainingBookingAttendes.push({
          name: "",
          email: "",
          phone: ""
        });
      }
    }
  }
};
</script>

<style>
</style>